document.addEventListener('DOMContentLoaded', function () {
  var root = document.getElementById('panda-tamanho-popup');
  if (!root) return;

  var metaEl = document.querySelector('[data-tp-meta]');
  var meta = {};
  try {
    meta = JSON.parse(metaEl.textContent);
  } catch (e) {
    meta = {};
  }

  var sizeOptionIndex = parseInt(root.dataset.sizeOptionIndex, 10);
  var whatsappPhone = (root.dataset.whatsappPhone || '').replace(/\D/g, '');

  var eyebrowEl = root.querySelector('[data-tp-eyebrow]');
  var headingEl = root.querySelector('[data-tp-heading]');
  var backBtn = root.querySelector('[data-tp-back]');
  var steps = root.querySelectorAll('[data-tp-step]');
  var scrollEl = root.querySelector('.panda-tp__scroll');

  var flowStack = [];
  var lastAro = {}; // último aro calculado por método (anel/anel-tela/fio), pra "usar esse tamanho"

  // ── TRAVA DE SCROLL DA PÁGINA (compartilhada pelos 3 popups: fluxo
  // principal, tabela e vídeo) ──
  // O <html> deste tema tem overflow-y:auto próprio (padrão do Dawn, pra
  // reservar sempre o espaço da barra de rolagem) — ou seja, é ELE quem
  // rola a página, não o <body>. Travar só o overflow do body (como estava
  // antes) não impede a página de trás de rolar, e ainda dava a impressão
  // de "2 barras de rolagem" (a da página, que continuava ativa, mais a do
  // conteúdo do popup). Uma contagem simples evita destravar cedo demais
  // quando um popup abre outro por cima (ex.: tabela aberta a partir do
  // fluxo principal, sem fechar ele).
  var scrollLockCount = 0;
  function lockPageScroll() {
    scrollLockCount++;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }
  function unlockPageScroll() {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount === 0) {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
  }

  function showStep(step) {
    steps.forEach(function (s) {
      s.classList.toggle('active', s.dataset.tpStep === step);
    });
    var m = meta[step];
    if (m) {
      if (eyebrowEl) eyebrowEl.textContent = m.eyebrow;
      if (headingEl) headingEl.textContent = m.heading;
    }
    if (backBtn) backBtn.style.display = flowStack.length ? 'inline-flex' : 'none';
    if (scrollEl) scrollEl.scrollTop = 0;
    // A 1ª calibração roda no DOMContentLoaded, com essa etapa ainda
    // display:none — getBoundingClientRect() media 0 e o círculo do anel
    // ficava travado até o slider da tela ser tocado manualmente. Recalibrar
    // toda vez que a etapa fica visível (inclusive voltando pelo "back")
    // resolve isso e também reflete mudanças reais de viewport/zoom.
    if (step === 'anel-tela' && telaSlider) {
      calibrateTela(telaSlider.value);
    }
  }

  function goTo(step) {
    var current = root.querySelector('[data-tp-step].active');
    if (current) flowStack.push(current.dataset.tpStep);
    showStep(step);
  }

  function back() {
    var prev = flowStack.pop();
    if (prev) {
      showStep(prev);
    } else {
      closePopup();
    }
  }

  function openPopup() {
    if (!root.classList.contains('panda-is-open')) lockPageScroll();
    flowStack = [];
    root.classList.add('panda-is-open');
    showStep('entry');
  }

  function closePopup() {
    root.classList.remove('panda-is-open');
    unlockPageScroll();
  }

  window.pandaOpenTamanhoPopup = openPopup;

  // Gatilho global: qualquer elemento com [data-open-tamanho-popup] abre o popup
  // (botão flutuante e o link "não sei meu tamanho" na página de produto).
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-open-tamanho-popup]');
    if (trigger) {
      e.preventDefault();
      openPopup();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (root.classList.contains('panda-is-open')) closePopup();
    closeTabela();
    closeVideo();
  });

  // O wrapper de scroll cobre a área toda (pra permitir rolar o popup), então
  // um clique nele mesmo (não em algum filho, como o painel) conta como
  // "clique fora do painel" e fecha — só a .panda-tp__overlay de fato não é
  // clicável nessa área porque o wrapper de scroll fica visualmente por cima.
  if (scrollEl) {
    scrollEl.addEventListener('click', function (e) {
      if (e.target === scrollEl) closePopup();
    });
  }

  // ── DELEGAÇÃO DE CLIQUES (popup principal) ──
  root.addEventListener('click', function (e) {
    // checa o botão de tutorial ANTES do goto: ele fica dentro de um card que
    // também tem [data-tp-goto], então precisa ganhar prioridade aqui.
    var tutorialTarget = e.target.closest('[data-tp-tutorial]');
    if (tutorialTarget) {
      e.stopPropagation();
      openVideo(tutorialTarget.dataset.tpTutorial);
      return;
    }
    var closeTarget = e.target.closest('[data-tp-close]');
    if (closeTarget) {
      closePopup();
      return;
    }
    var backTarget = e.target.closest('[data-tp-back]');
    if (backTarget) {
      back();
      return;
    }
    var gotoTarget = e.target.closest('[data-tp-goto]');
    if (gotoTarget) {
      goTo(gotoTarget.dataset.tpGoto);
      return;
    }
    var tabelaTarget = e.target.closest('[data-tp-tabela]');
    if (tabelaTarget) {
      openTabela();
      return;
    }
    var calcTarget = e.target.closest('[data-tp-calc]');
    if (calcTarget) {
      runCalc(calcTarget.dataset.tpCalc);
      return;
    }
    var useSizeTarget = e.target.closest('[data-tp-use-size]');
    if (useSizeTarget && !useSizeTarget.disabled) {
      useSize(useSizeTarget.dataset.tpUseSize);
      return;
    }
    var fallbackToggleTarget = e.target.closest('[data-tp-fallback-toggle]');
    if (fallbackToggleTarget) {
      var panel = root.querySelector('[data-tp-fallback="' + fallbackToggleTarget.dataset.tpFallbackToggle + '"]');
      if (panel) panel.classList.toggle('open');
      return;
    }
    var dayTarget = e.target.closest('[data-tp-day]');
    if (dayTarget) {
      selectDay(dayTarget);
      return;
    }
    var slotTarget = e.target.closest('[data-tp-slot]');
    if (slotTarget) {
      selectSlot(slotTarget);
      return;
    }
    var confirmTarget = e.target.closest('[data-tp-fallback-confirm]');
    if (confirmTarget && !confirmTarget.disabled) {
      confirmFallback(confirmTarget.dataset.tpFallbackConfirm);
      return;
    }
    var printTarget = e.target.closest('[data-tp-print-print]');
    if (printTarget) {
      printRuler();
      return;
    }
    var resetTarget = e.target.closest('[data-tp-reset-sliders]');
    if (resetTarget) {
      resetSliders();
      return;
    }
  });

  // Clona o conteúdo da régua pro container exclusivo de impressão logo antes
  // de imprimir — evita que o resto da página (escondida, mas ainda ocupando
  // altura em layout) faça a régua repetir em várias páginas impressas.
  function printRuler() {
    var source = root.querySelector('[data-tp-print-area]');
    var standalone = document.querySelector('[data-tp-print-standalone]');
    if (!source || !standalone) {
      window.print();
      return;
    }
    standalone.innerHTML = source.innerHTML;
    window.print();
  }

  // ── CÁLCULO DE TAMANHO ──
  // Método "fio" (circunferência, medida com fio/fita): fórmula alinhada à
  // tabela real da marca ("Tabela de medidas" — aro 10 = 5,00cm de
  // circunferência ... aro 35 = 7,50cm), que é linear: circunferência (mm) =
  // aro + 40. NÃO é a mesma relação geométrica (π × diâmetro) usada na tabela
  // de exemplo de panda-guia-tamanhos.liquid — essa tabela de exemplo nunca
  // foi substituída pelos números reais da marca, então não é fonte de
  // verdade pra essa conta.
  // Campos de entrada em cm; convertidos para mm antes de aplicar a fórmula.
  function clampAro(mm) {
    return Math.max(10, Math.min(35, Math.round(mm)));
  }

  function runCalc(method) {
    var aro;
    var noteValue = null;

    if (method === 'anel-tela') {
      var ringSlider = root.querySelector('[data-tp-ring-slider]');
      if (!ringSlider) return;
      var ringCm = parseFloat(ringSlider.value);
      aro = clampAro(ringCm * 10);
    } else {
      var input = root.querySelector('[data-tp-input="' + method + '"]');
      if (!input) return;
      var rawCm = parseFloat((input.value || '').replace(',', '.'));
      if (!rawCm || rawCm <= 0) return;
      var rawMm = rawCm * 10;
      if (method === 'anel') {
        aro = clampAro(rawMm);
      } else if (method === 'fio') {
        aro = clampAro(rawMm - 40);
        noteValue = rawCm.toFixed(2).replace('.', ',');
      }
    }
    lastAro[method] = aro;

    var resultEl = root.querySelector('[data-tp-result="' + method + '"]');
    if (!resultEl) return;
    resultEl.querySelector('[data-tp-result-val]').textContent = 'Aro ' + aro;
    var noteEl = resultEl.querySelector('[data-tp-result-note]');
    if (noteEl) {
      var template = noteEl.dataset.noteTemplate || '';
      noteEl.textContent = noteValue ? template.replace('[cm]', noteValue) : template;
    }
    resultEl.classList.add('show');

    var useBtn = resultEl.querySelector('[data-tp-use-size]');
    if (useBtn) {
      var match = findOptionValueForAro(aro);
      useBtn.style.display = match ? '' : 'none';
    }
  }

  // ── INTEGRAÇÃO COM O SELETOR DE VARIANTE DA PÁGINA DE PRODUTO ──
  function findOptionValueForAro(aro) {
    if (isNaN(sizeOptionIndex) || sizeOptionIndex < 0) return null;
    var select = document.querySelector('[data-option-select][data-option-index="' + sizeOptionIndex + '"]');
    if (!select) return null;
    var options = Array.prototype.slice.call(select.options);
    var match = options.find(function (opt) {
      var digits = opt.value.match(/\d+/);
      return digits && parseInt(digits[0], 10) === aro;
    });
    return match ? { select: select, value: match.value } : null;
  }

  function useSize(method) {
    var aro = lastAro[method];
    var match = findOptionValueForAro(aro);
    closePopup();
    if (!match) return;
    match.select.value = match.value;
    match.select.dispatchEvent(new Event('change', { bubbles: true }));
    var field = match.select.closest('.panda-pi-field') || match.select;
    setTimeout(function () {
      field.scrollIntoView({ behavior: 'smooth', block: 'center' });
      field.classList.add('panda-tp-just-set');
      setTimeout(function () { field.classList.remove('panda-tp-just-set'); }, 1600);
    }, 350);
  }

  // ── ANEL NA TELA: calibração por cartão de crédito + círculo real ──
  // O cartão NÃO é dimensionado em cm de CSS — testamos com régua física e
  // confirmado que a conversão nominal do navegador (96px/polegada) não bate
  // com o tamanho real em tela (um cartão "8,56cm" de CSS mede uns 9cm de
  // verdade). Em vez disso, seguimos a mesma abordagem do protótipo original
  // (Tema Panda HTML/popupsV2.html, printCalibrate): o cartão é dimensionado
  // direto em px, ancorado num ponto de referência verificado com régua real
  // nessa mesma tela de teste (300px = 8,56cm reais), não na suposição
  // teórica do CSS. O slider (80–120%) ajusta esse px em torno desse ponto.
  var telaCard = root.querySelector('[data-tp-tela-card]');
  var telaSlider = root.querySelector('[data-tp-tela-slider]');
  var telaReadout = root.querySelector('[data-tp-tela-readout]');
  var ringCircle = root.querySelector('[data-tp-ring-circle]');
  var ringSliderEl = root.querySelector('[data-tp-ring-slider]');
  var ringReadout = root.querySelector('[data-tp-ring-readout]');
  var telaPxPerCm = null;

  var CARD_W_CM = 8.56;
  var CARD_H_CM = 5.398;
  var BASE_CARD_PX = 300; // referência real verificada com régua física (8,56cm)

  function calibrateTela(percent) {
    if (!telaCard) return;
    var px = BASE_CARD_PX * (percent / 100);
    telaCard.style.width = px + 'px';
    telaCard.style.height = (px * (CARD_H_CM / CARD_W_CM)) + 'px';
    telaPxPerCm = px / CARD_W_CM;
    // o texto do readout é o alvo fixo (tamanho real do cartão) — não muda
    // com o slider, só o retângulo muda; o slider é o que o usuário ajusta
    // até o retângulo bater visualmente com esse alvo.
    if (telaReadout && !telaReadout.dataset.rendered) {
      var cmLabel = CARD_W_CM.toFixed(2).replace('.', ',') + 'cm';
      telaReadout.textContent = telaReadout.textContent.replace('[cm]', cmLabel);
      telaReadout.dataset.rendered = 'true';
    }
    renderRing();
  }

  function renderRing() {
    if (!ringCircle || !ringSliderEl || !telaPxPerCm) return;
    var ringCm = parseFloat(ringSliderEl.value);
    var px = ringCm * telaPxPerCm;
    ringCircle.style.width = px + 'px';
    ringCircle.style.height = px + 'px';
    if (ringReadout) ringReadout.textContent = ringCm.toFixed(2).replace('.', ',') + 'cm';
  }

  function resetSliders() {
    if (telaSlider) {
      telaSlider.value = telaSlider.dataset.default || 100;
      calibrateTela(telaSlider.value);
    }
    if (ringSliderEl) {
      ringSliderEl.value = ringSliderEl.dataset.default || 1.7;
      renderRing();
    }
  }

  if (telaSlider) {
    telaSlider.addEventListener('input', function () {
      calibrateTela(telaSlider.value);
    });
  }
  if (ringSliderEl) {
    ringSliderEl.addEventListener('input', renderRing);
  }

  // ── POPUP — TABELA DE MEDIDAS (imagem) ──
  var tabelaPopup = document.getElementById('panda-tamanho-tabela');
  function openTabela() {
    if (!tabelaPopup) return;
    if (!tabelaPopup.classList.contains('panda-is-open')) lockPageScroll();
    tabelaPopup.classList.add('panda-is-open');
  }
  function closeTabela() {
    if (!tabelaPopup || !tabelaPopup.classList.contains('panda-is-open')) return;
    tabelaPopup.classList.remove('panda-is-open');
    unlockPageScroll();
  }
  if (tabelaPopup) {
    tabelaPopup.querySelectorAll('[data-tp-tabela-close]').forEach(function (el) {
      el.addEventListener('click', closeTabela);
    });
    var tabelaScroll = tabelaPopup.querySelector('.panda-tp-image-popup__scroll');
    if (tabelaScroll) {
      tabelaScroll.addEventListener('click', function (e) {
        if (e.target === tabelaScroll) closeTabela();
      });
    }
  }

  // ── POPUP — VÍDEO TUTORIAL ──
  var videoPopup = document.getElementById('panda-tamanho-video');
  function openVideo(cardKey) {
    if (!videoPopup) return;
    videoPopup.querySelectorAll('[data-tp-video-slot]').forEach(function (slot) {
      var isMatch = slot.dataset.tpVideoSlot === cardKey;
      slot.classList.toggle('active', isMatch);
      var media = slot.querySelector('video');
      if (media) {
        if (isMatch) {
          media.currentTime = 0;
          media.play().catch(function () {});
        } else {
          media.pause();
        }
      }
    });
    if (!videoPopup.classList.contains('panda-is-open')) lockPageScroll();
    videoPopup.classList.add('panda-is-open');
  }
  function closeVideo() {
    if (!videoPopup || !videoPopup.classList.contains('panda-is-open')) return;
    videoPopup.classList.remove('panda-is-open');
    videoPopup.querySelectorAll('video').forEach(function (media) {
      media.pause();
    });
    unlockPageScroll();
  }
  if (videoPopup) {
    videoPopup.querySelectorAll('[data-tp-video-close]').forEach(function (el) {
      el.addEventListener('click', closeVideo);
    });
    var videoScroll = videoPopup.querySelector('.panda-tp-image-popup__scroll');
    if (videoScroll) {
      videoScroll.addEventListener('click', function (e) {
        if (e.target === videoScroll) closeVideo();
      });
    }
  }

  // ── FALLBACK: VIDEOCHAMADA (dias reais, gerados a partir de hoje) ──
  var DOW = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
  var fallbackState = {};

  function buildUpcomingWeekdays(count) {
    var days = [];
    var d = new Date();
    d.setDate(d.getDate() + 1);
    while (days.length < count) {
      if (d.getDay() !== 0 && d.getDay() !== 6) {
        days.push({ label: DOW[d.getDay()], num: d.getDate() });
      }
      d.setDate(d.getDate() + 1);
    }
    return days;
  }

  root.querySelectorAll('[data-tp-days]').forEach(function (wrap) {
    var days = buildUpcomingWeekdays(5);
    days.forEach(function (day, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'panda-tp-day' + (i === 0 ? ' active' : '');
      btn.dataset.tpDay = wrap.dataset.tpDays;
      btn.dataset.day = day.label + ' ' + day.num;
      btn.innerHTML = '<div class="panda-tp-day-dow">' + day.label + '</div><div class="panda-tp-day-num">' + day.num + '</div>';
      wrap.appendChild(btn);
    });
    var method = wrap.dataset.tpDays;
    fallbackState[method] = fallbackState[method] || {};
    fallbackState[method].day = days[0].label + ' ' + days[0].num;
  });

  function selectDay(el) {
    var method = el.dataset.tpDay;
    el.parentNode.querySelectorAll('[data-tp-day]').forEach(function (d) { d.classList.remove('active'); });
    el.classList.add('active');
    fallbackState[method] = fallbackState[method] || {};
    fallbackState[method].day = el.dataset.day;
    var resultEl = root.querySelector('[data-tp-fallback-result="' + method + '"]');
    if (resultEl) resultEl.classList.remove('show');
  }

  function selectSlot(el) {
    var method = el.dataset.tpSlot;
    el.parentNode.querySelectorAll('[data-tp-slot]').forEach(function (s) { s.classList.remove('active'); });
    el.classList.add('active');
    fallbackState[method] = fallbackState[method] || {};
    fallbackState[method].slot = el.dataset.slot;
    var confirmBtn = root.querySelector('[data-tp-fallback-confirm="' + method + '"]');
    if (confirmBtn) confirmBtn.disabled = false;
    var resultEl = root.querySelector('[data-tp-fallback-result="' + method + '"]');
    if (resultEl) resultEl.classList.remove('show');
  }

  function confirmFallback(method) {
    var st = fallbackState[method];
    if (!st || !st.slot) return;
    var day = st.day || '';
    var titleEl = root.querySelector('[data-tp-fallback-result="' + method + '"] [data-tp-fallback-confirm-title]');
    if (titleEl) titleEl.textContent = 'Chamada marcada: ' + day + ' às ' + st.slot + '.';
    var resultEl = root.querySelector('[data-tp-fallback-result="' + method + '"]');
    if (resultEl) resultEl.classList.add('show');

    if (whatsappPhone) {
      var messageTemplate = root.dataset.whatsappMessageTemplate || '';
      var message = messageTemplate.replace('[dia]', day).replace('[horario]', st.slot);
      window.open('https://wa.me/' + whatsappPhone + '?text=' + encodeURIComponent(message), '_blank', 'noopener');
    }
  }
});
